<template>
  <div class="page__container">
    <div class="page__title">
      Благодарим за регистрацию!
    </div>
    <div class="page__subtitle">
      На указанный вами почтовый адрес отправлено письмо. Для завершения процесса регистрации перейдите по содержащейся в нем ссылке.
    </div>
    <div class="btn__next" @click="$router.push({name: names.MAIN})">
        <span class="btn__next_text">
          На главную
        </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import { mapGetters } from "vuex"

export default defineComponent({
  name: "RegistrationInfoSentEmail",
  computed: {
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  created () {
    if (this.isAuthenticated) { this.$router.push({ name: names.MAIN }) }
  },
})
</script>

<style scoped lang="scss">
.page__container {
  width: 100%;
  max-width: 1280px;
  margin: 150px auto;
}

.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 250px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
